import { render, staticRenderFns } from "./TemplatesTable.vue?vue&type=template&id=07334dbf&scoped=true"
import script from "./TemplatesTable.vue?vue&type=script&lang=js"
export * from "./TemplatesTable.vue?vue&type=script&lang=js"
import style0 from "./TemplatesTable.vue?vue&type=style&index=0&id=07334dbf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07334dbf",
  null
  
)

export default component.exports